export default {
  metadata: {
    version: '1.0.0',
    id: 'button-1.0.0',
    name: 'JDSButton',
    description:
      'A button is an interactive control that allows the user to perform a specific action.',
    usage: 'A button accepts a user choice, response or command.'
  },
  hierarchy: {
    container: [
      {
        'left-container': ['left-icon', 'jds-text']
      },
      'right-icon',
      'loader'
    ]
  },
  base: {
    container: {
      opacity: '{b_0}',
      'background-color': '{b_1}',
      'flex-direction': '{b_2}',
      'align-items': '{b_3}',
      'justify-content': '{b_4}',
      'border-radius': '{b_5}',
      'border-width': '{b_6}',
      'border-color': '{b_7}',
      gap: '{b_8}',
      behavior: {
        hover: {
          'background-color': '{b_10}'
        },
        active: {
          'background-color': '{b_11}'
        },
        focus: {
          'border-width': '{b_12}',
          'border-color': '{b_13}'
        }
      }
    },
    'left-container': {
      hidden: false,
      'flex-direction': '{b_14}',
      'align-items': '{b_15}',
      'justify-content': '{b_16}',
      gap: '{b_17}',
      'flex-fill-android': false
    },
    loader: {
      color: '{b_18}',
      'background-color': '{b_19}',
      'border-width': '{b_20}',
      hidden: true,
      opacity: '{b_21}',
      size: '{b_22}'
    },
    'left-icon': {
      size: '{b_23}',
      color: '{b_24}',
      hidden: false
    },
    'right-icon': {
      size: '{b_25}',
      color: '{b_26}',
      hidden: false
    },
    'jds-text': {
      'font-family': '{text_187}',
      color: '{text_18}',
      'font-size': '{text_186}',
      'line-height': '{text_188}',
      'letter-spacing': '{text_189}',
      'font-weight': '{text_190}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      language: 'en'
    }
  },
  variant: {
    _hasLabel: {
      false: {
        'left-container': {
          hidden: true
        }
      }
    },
    fullWidth: {
      true: {
        container: {
          'justify-content': '{b_28}',
          width: '{b_27}',
          gap: 0
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{b_29}'
        }
      }
    },
    loading: {
      true: {
        container: {
          disabled: true
        },
        loader: {
          hidden: false
        },
        'right-icon': {
          hidden: true
        }
      }
    },
    _hasRightIcon: {
      false: {
        'right-icon': {
          hidden: true
        }
      }
    },
    _hasLeftIcon: {
      false: {
        'left-icon': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      primary: {
        normal: {
          'left-icon': {
            behavior: {
              active: {
                color: '{b_30}'
              }
            }
          },
          'right-icon': {
            behavior: {
              active: {
                color: '{b_31}'
              }
            }
          },
          'jds-text': {
            behavior: {
              hover: {},
              active: {
                color: '{text_16}'
              }
            }
          }
        },
        destructive: {
          container: {
            'background-color': '{b_32}',
            behavior: {
              hover: {
                'background-color': '{b_33}'
              },
              active: {
                'background-color': '{b_34}'
              },
              focus: {
                'border-color': '{b_35}'
              }
            }
          },
          loader: {
            color: '{b_36}'
          },
          'left-icon': {
            color: '{b_37}',
            behavior: {
              hover: {
                color: '{b_38}'
              },
              active: {
                color: '{b_39}'
              }
            }
          },
          'right-icon': {
            color: '{b_41}',
            behavior: {
              hover: {
                color: '{b_40}'
              },
              active: {
                color: '{b_42}'
              }
            }
          },
          'jds-text': {
            color: '{text_53}',
            behavior: {
              hover: {
                color: '{text_62}'
              },
              active: {
                color: '{text_55}'
              }
            }
          }
        },
        positive: {
          container: {
            'background-color': '{b_43}',
            behavior: {
              hover: {
                'background-color': '{b_44}'
              },
              active: {
                'background-color': '{b_45}'
              },
              focus: {
                'border-color': '{b_46}'
              }
            }
          },
          loader: {
            color: '{b_47}'
          },
          'left-icon': {
            color: '{b_48}',
            behavior: {
              hover: {
                color: '{b_49}'
              },
              active: {
                color: '{b_50}'
              }
            }
          },
          'right-icon': {
            color: '{b_51}',
            behavior: {
              hover: {
                color: '{b_52}'
              },
              active: {
                color: '{b_53}'
              }
            }
          },
          'jds-text': {
            color: '{text_59}',
            behavior: {
              hover: {
                color: '{text_62}'
              },
              active: {
                color: '{text_61}'
              }
            }
          }
        }
      },
      secondary: {
        normal: {
          container: {
            'background-color': '{b_54}',
            'border-width': '{b_55}',
            'border-color': '{b_56}',
            behavior: {
              hover: {
                'border-color': '{b_57}',
                'background-color': '{b_58}'
              },
              active: {
                'background-color': '{b_59}',
                'border-color': '{b_60}'
              },
              focus: {
                'border-color': '{b_61}'
              }
            }
          },
          loader: {
            color: '{b_62}'
          },
          'left-icon': {
            color: '{b_63}'
          },
          'right-icon': {
            color: '{b_64}'
          },
          'jds-text': {
            color: '{text_13}'
          }
        },
        destructive: {
          container: {
            'background-color': '{b_65}',
            'border-width': '{b_66}',
            'border-color': '{b_67}',
            behavior: {
              active: {
                'background-color': '{b_68}',
                'border-color': '{b_69}'
              },
              focus: {
                'border-color': '{b_70}',
                'border-width': '{b_71}'
              }
            }
          },
          loader: {
            color: '{b_72}'
          },
          'left-icon': {
            color: '{b_73}'
          },
          'right-icon': {
            color: '{b_74}'
          },
          'jds-text': {
            color: '{text_53}'
          }
        },
        positive: {
          container: {
            'background-color': '{b_75}',
            'border-width': '{b_76}',
            'border-color': '{b_77}',
            behavior: {
              active: {
                'background-color': '{b_78}',
                'border-color': '{b_79}'
              },
              focus: {
                'border-color': '{b_80}',
                'border-width': '{b_81}'
              }
            }
          },
          loader: {
            color: '{b_82}'
          },
          'left-icon': {
            color: '{b_83}'
          },
          'right-icon': {
            color: '{b_84}'
          },
          'jds-text': {
            color: '{text_59}'
          }
        }
      },
      tertiary: {
        normal: {
          container: {
            'border-width': '{b_9}',
            'background-color': '{b_85}',
            behavior: {
              hover: {
                'background-color': '{b_86}'
              },
              active: {
                'background-color': '{b_87}'
              },
              focus: {
                'border-color': '{b_88}',
                'background-color': '{b_89}'
              }
            }
          },
          loader: {
            color: '{b_90}'
          },
          'left-icon': {
            color: '{b_91}'
          },
          'right-icon': {
            color: '{b_92}'
          },
          'jds-text': {
            color: '{text_13}'
          }
        },
        destructive: {
          container: {
            'background-color': '{b_93}',
            behavior: {
              hover: {
                'background-color': '{b_94}'
              },
              active: {
                'background-color': '{b_95}'
              },
              focus: {
                'border-color': '{b_96}',
                'border-width': '{b_97}',
                'background-color': '{b_98}'
              }
            }
          },
          loader: {
            color: '{b_99}'
          },
          'left-icon': {
            color: '{b_100}'
          },
          'right-icon': {
            color: '{b_101}'
          },
          'jds-text': {
            color: '{text_53}'
          }
        },
        positive: {
          container: {
            'background-color': '{b_102}',
            behavior: {
              active: {
                'background-color': '{b_103}'
              },
              focus: {
                'border-color': '{b_104}',
                'border-width': '{b_105}'
              }
            }
          },
          loader: {
            color: '{b_106}'
          },
          'left-icon': {
            color: '{b_107}'
          },
          'right-icon': {
            color: '{b_108}'
          },
          'jds-text': {
            color: '{text_59}'
          }
        }
      }
    },
    {
      true: {
        small: {
          container: {
            'padding-top': '{b_109}',
            'padding-right': '{b_110}',
            'padding-bottom': '{b_111}',
            'padding-left': '{b_112}'
          },
          'left-icon': {
            size: '{b_113}'
          },
          'right-icon': {
            size: '{b_114}'
          },
          loader: {
            size: '{b_115}'
          }
        },
        medium: {
          container: {
            'padding-top': '{b_116}',
            'padding-right': '{b_117}',
            'padding-bottom': '{b_118}',
            'padding-left': '{b_119}'
          },
          'left-icon': {
            size: '{b_120}'
          },
          'right-icon': {
            size: '{b_121}'
          },
          loader: {
            size: '{b_122}'
          }
        },
        large: {
          container: {
            'padding-top': '{b_123}',
            'padding-left': '{b_124}',
            'padding-bottom': '{b_125}',
            'padding-right': '{b_126}'
          },
          'left-icon': {
            size: '{b_127}'
          },
          'right-icon': {
            size: '{b_128}'
          },
          loader: {
            size: '{b_129}'
          }
        }
      },
      false: {
        small: {
          container: {
            'min-height': '{b_130}',
            'min-width': '{b_131}'
          },
          'left-icon': {
            size: '{b_132}'
          },
          'right-icon': {
            size: '{b_133}'
          },
          loader: {
            size: '{b_134}'
          },
          'jds-text': {
            hidden: true
          }
        },
        medium: {
          container: {
            'min-height': '{b_135}',
            'min-width': '{b_136}'
          },
          'left-icon': {
            size: '{b_137}'
          },
          'right-icon': {
            size: '{b_138}'
          },
          loader: {
            size: '{b_139}'
          },
          'jds-text': {
            hidden: true
          }
        },
        large: {
          container: {
            'min-height': 56,
            'min-width': 56
          },
          'left-icon': {
            size: '{b_140}'
          },
          'right-icon': {
            size: '{b_141}'
          },
          loader: {
            size: '{b_142}'
          },
          'jds-text': {
            hidden: true
          }
        }
      }
    },
    {
      true: {
        true: {
          true: {
            false: {
              false: {
                container: {
                  'justify-content': '{b_143}'
                }
              },
              true: {
                container: {
                  'justify-content': '{b_144}'
                }
              }
            }
          }
        },
        false: {
          false: {
            true: {
              false: {
                container: {
                  'justify-content': '{b_145}'
                }
              }
            },
            false: {
              true: {
                container: {
                  'justify-content': '{b_146}'
                }
              }
            }
          },
          true: {
            true: {
              false: {
                container: {
                  'justify-content': '{b_147}'
                }
              }
            }
          }
        }
      }
    }
  ],
  combination_config: [
    ['kind', 'state'],
    ['_hasLabel', 'size'],
    ['fullWidth', '_hasRightIcon', '_hasLeftIcon', '_hasLabel', 'loading']
  ],
  api: {
    config: {
      kind: {
        values: ['primary', 'secondary', 'tertiary'],
        doc_description:
          "It can be used to switch between 3 variants of Button which is by default 'primary'."
      },
      size: {
        values: ['medium', 'small', 'large'],
        doc_description: 'it can be used to control the size of Button.'
      },
      state: {
        values: ['normal', 'destructive', 'positive'],
        doc_description: 'It can be used to change the state of Button.'
      },
      fullWidth: {
        values: [false, true],
        doc_description: 'It can be used to make Button full-width.'
      },
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable Button.'
      },
      _hasRightIcon: {
        values: [true, false]
      },
      _hasLeftIcon: {
        values: [true, false]
      },
      loading: {
        values: [false, true],
        doc_description:
          'This can be used to add loading spinner to the right of label in Button.'
      },
      _hasLabel: {
        values: [true, false]
      }
    },
    data: {
      container: {
        type: {
          name: 'type',
          type: 'string',
          platform: 'web'
        }
      },
      'left-icon': {
        value: {
          type: 'icon',
          name: 'iconLeft',
          doc_description:
            'It can be used to add icon to the left of the text of Button.'
        },
        description: {
          type: 'string',
          name: 'description'
        }
      },
      'right-icon': {
        value: {
          type: 'icon',
          name: 'icon',
          doc_description: 'It adds icon to the right of the text of Button.'
        },
        description: {
          type: 'string',
          name: 'description'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of Button.'
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick',
        onFocus: {
          name: 'onFocus',
          platform: 'web'
        },
        onBlur: {
          name: 'onBlur',
          platform: 'web'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'button'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-expanded': 'ariaExpanded',
          'aria-controls': 'ariaControls'
        }
      },
      'right-icon': {
        properties: {
          role: {
            value: 'img'
          },
          'aria-label': {
            name: 'iconAriaLabel',
            function: true
          }
        }
      }
    }
  }
};
